import { createAction } from 'eight.js.ui-common';

export const toggleSidebar = createAction('@@ui/TOGGLE_SIDEBAR');
